// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    loadContactDetails,
    updateContactDetails,
} from '../../redux/reducers/contacts';

import Loader from '../../components/Loader/Loader';
import MessageBlock from '../../components/MessageBlock/MessageBlock';

import FormWrapper from '../../components/shared/FormWrapper';

import ContactEditForm from '../../components/Contacts/Edit';

class ContactsEdit extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(
            loadContactDetails(this.props.match.params.contactId)
        );
    }

    onSubmit(formValues) {
        const { dispatch, contact, history } = this.props;

        const contactData = {
            contactEmail: formValues.email,
            contactForenames: formValues.forenames,
            contactSurname: formValues.surname,
            contactTelephone: formValues.telephone,
            contactTitle: formValues.title,
        };

        dispatch(
            updateContactDetails(contact.contactId, contactData)
        ).then(updatedContact => {
            history.push('/contacts');
        });
    }

    render() {
        const { contact, isFetching, errorFetching } = this.props;

        if (errorFetching) {
            return (
                <FormWrapper>
                    <MessageBlock message="An unexpected error occurred whilst loading this contact." />
                </FormWrapper>
            );
        }

        if (isFetching) {
            return (
                <FormWrapper>
                    <Loader message="Loading contact, please wait..." />
                </FormWrapper>
            );
        }

        if (!isFetching && contact) {
            const initialValues = {
                title: contact.contactTitle,
                forenames: contact.contactForenames,
                surname: contact.contactSurname,
                telephone: contact.contactTelephone,
                email: contact.contactEmail,
            };

            return (
                <FormWrapper>
                    <ContactEditForm
                        contact={contact}
                        initialValues={initialValues}
                        onSubmit={this.onSubmit}
                    />
                </FormWrapper>
            );
        }

        return null;
    }
}

const mapStateToProps = state => {
    const edit = state.contacts.edit;

    return {
        errorFetching: edit.error,
        isFetching: edit.fetching,
        contact: edit.contact,
    };
};

export default withRouter(connect(mapStateToProps)(ContactsEdit));



// WEBPACK FOOTER //
// ./src/containers/ContactsEdit/ContactsEdit.js